import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLargeRight"><Path d="M9.5 2.5L14.5 12L9.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLargeRight;
